import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import PageHeader1 from "../../components/common/PageHeader1";
import { useForm } from "react-hook-form";
import st from "./DynamicForm.module.scss";
import { useNavigate } from "react-router-dom";

import _ from "lodash";
import { DataGrid } from "@mui/x-data-grid";
import UserDataModel from "./userDataModel";
import { getUserListApi,handleDeleteUser } from "../../services/User";


function ProductList() {
   const navigate = useNavigate();
  const [ismodel, setIsModel] = useState(false);
  const [userModel, setUserModel] = useState(false);
  const setUserCloseModel = () => {
    clearData();
    setUserModel(false);
  }
  const [changeStatusTo, setChangeStatusTo] = useState({});
  const [getUserData, setgetUserData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [userList, setUserList] = useState([]);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [searchInput, setSearchInput] = useState("");
  const [searchTrigger, setSearchTrigger] = useState("");
  const [referralSource, setReferralSource] = useState("");
  const [totalUsers, setTotalUsers] = useState(0);

  const { reset } = useForm();


  const getFilter = (data) => {
    setUserModel(true);
    setgetUserData(data)
  }

  const capitalizeFirstLetter = (string) => {
    if (!string || typeof string !== 'string') return string; // Handle null, undefined, or non-string types
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };
 
  const columns = () => {
    return [
      {
        field: "sno",
        headerName: "S.No.",
        sortable: true,
        width: 100,
      },
      
      {
        field: "profile_picture",
        headerName: "Profile",
        width: 100,
        renderCell: (params) => {
          const imageUrl = params.value ? `${params.value}` : "/default-avatar.jpg";
          return (
            <img
              src={imageUrl}
              alt="Profile"
              style={{
                width: 40,
                height: 40,
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
          );
        },
      },
      {
        field: "first_name",
        headerName: "First Name",
        sortable: true,
        width: 200,
      },
      
      {
        field: "last_name",
        headerName: "Last Name",
        sortable: true,
        width: 200,
      },
      {
        field: "email",
        headerName: "Email",
        sortable: true,
        width: 200,
      },
      {
        field: "mobile",
        headerName: "Mobile No.",
        sortable: false,
        width: 100,
      },
      {
        field: "action",
        headerName: "ACTION",
        sortable: false,
        width: 100,
        renderCell: (params) => (
          console.log("params", params),
          <div className="btn-group">
            {/* 
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => {
                getFilter(params.row)
              }}
            >
              <i className="icofont-eye-alt"></i>
            </button>
            */}

            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={() => navigate(`/user-details/${params.row._id || params.row.id}`)}
              title="View"
            >
              <i className="icofont-eye-alt"></i>
            </button>
      
            <button
              type="button" 
              className="btn btn-outline-danger"
              onClick={() => handleDeleteUser(params.row._id,getProductList)}
            >
              <i className="icofont-ui-delete"></i>
            </button>
          </div>
        ),
      },
    ]
  };

  async function getProductList() {
    setIsLoading(true);
    try {
      const response = await getUserListApi({ page: page + 1, limit, search: searchTrigger, referral_source: referralSource });
      const { data, total } = await response; 
      
      setTotalUsers(total || 0);
  
      setUserList(
        data?.map((item, i) => {
          let preference = item?.dietaryPreference; 
          if (preference && typeof preference === 'string' && preference.trim() !== '') {
            preference = capitalizeFirstLetter(preference);
          } else {
            preference = "-"; 
          }
  
          return {
            ...item,
            id: item?._id,
            sno: (page * limit) + i + 1,
            dietaryPreference: preference, 
          };
        }) || [] 
      );
    } catch (error) {
      console.error("Error fetching product data:", error);
    } finally {
      reset();
      setIsLoading(false);
    }
  }

  const clearData = () => {
    setgetUserData({});
    setChangeStatusTo({});
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setSearchTrigger(searchInput);
      if (page !== 0) {
        setPage(0); // Reset page on new search
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [searchInput]);

  useEffect(() => {
    getProductList();
  }, [page, limit, searchTrigger, referralSource]);

  return (
    <div className="body d-flex py-lg-3 py-md-2">
      <div className="container-xxl">
        <PageHeader1
          pagetitle="User Information"
          modalbutton={() => {
            return (
              <div className="col-auto d-flex w-sm-100">
                {/* <button
                  type="button"
                  className="btn btn-primary btn-set-task w-sm-100"
                >
                  <i className="icofont-plus-circle me-2 fs-6"></i>Add Product
                </button> */}
              </div>
            );
          }}
        />

        <div className="row clearfix g-3">
          <div className="col-sm-12 mt-3">
            <div className="card">
              <div className="card-body">
                <div
                  id="myProjectTable_wrapper"
                  className="dataTables_wrapper dt-bootstrap5 no-footer"
                >
                  <div className="row mb-3">
                    <div className="col-sm-12 col-md-6">
                      <input 
                        type="text" 
                        className="form-control" 
                        placeholder="Search by first name, last name, email or mobile..." 
                        value={searchInput}
                        onChange={(e) => setSearchInput(e.target.value)}
                      />
                    </div>
                    <div className="col-sm-12 col-md-3">
                      <select className="form-control" value={referralSource} onChange={(e) => { setReferralSource(e.target.value); setPage(0); }}>
                        <option value="">All Referral Sources</option>
                        <option value="Deep Mind Transitions">Deep Mind Transitions</option>
                        <option value="Social Media">Social Media</option>
                        <option value="Internet">Internet</option>
                        <option value="Friend/Word of mouth">Friend/Word of mouth</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      {userList && <DataGrid
                        rows={userList}
                        columns={columns()}
                        loading={isLoading}
                        paginationMode="server"
                        rowCount={totalUsers}
                        paginationModel={{ page, pageSize: limit }}
                        onPaginationModelChange={(newModel) => {
                          setPage(newModel.page);
                          setLimit(newModel.pageSize);
                        }}
                        pageSizeOptions={[8, 10, 25, 50]}
                        sx={{
                          border: "none",
                          "& .MuiDataGrid-root": {
                            border: "none",
                          },
                        }}
                      />}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={ismodel}
        onHide={() => {
          clearData();
          setIsModel(false);
        }}
        style={{ display: "block" }}
      >
        <Modal.Header className="modal-header" closeButton>
          <h5 className="modal-title  fw-bold" id="expaddLabel">
            {changeStatusTo?.modelHeading}
          </h5>
        </Modal.Header>
        <Modal.Body className="modal-body">
          <div className="deadline-form">
            <form>
              <h4
                style={{
                  textAlign: "center",
                  fontSize: "22px",
                  fontWeight: "600",
                  marginBottom: "20px",
                }}
              >
                Are you sure you want to change the status to{" "}
                {changeStatusTo.status}?
              </h4>
              <div className={`${st.modalButtonBottom}`}>
                <button
                  onClick={() => {
                    setIsModel(false);
                    setChangeStatusTo({});
                  }}
                  type="button"
                  className="btn btn-secondary"
                >
                  Cancel
                </button>
                <button
                  // onClick={onStatusSubmit}
                  type="button"
                  className="btn btn-primary"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>

      <UserDataModel
        userModel={userModel}
        setUserCloseModel={setUserCloseModel}
        getUserData={getUserData} />

    </div>
  );
}
export default ProductList;
